import cn from 'classnames';
import {useParams} from 'react-router-dom';
import {selectProject} from '../../../redux/selectors';
import {useAppSelector} from '../../hooks';
import './invest-success.sass';

interface IProps {
  className?: string;
}

function InvestSuccess(props: IProps) {
  const {projectId: id} = useParams<{projectId: string}>();
  const project = useAppSelector(selectProject(id));
  if (!project) return null;
  return (
    <div className={cn('invest-success', props.className)}>
      <div className="invest-success__title">{project.successTitle}</div>
      <div className="invest-success__desc">{project.successDescription}</div>
    </div>
  );
}

export default InvestSuccess;
